<template>
  <div class="wrapper">
    <div>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="姓名">
          <el-input v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="参与人类型">
          <el-select
            v-model="form.userType"
            @change="handleChangeAttend"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in attendList"
              :key="item.userType"
              :label="item.keyword"
              :value="item.userType"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="targetAttend.company" :label="targetAttend.company">
          <el-select
            v-model="form.companyId"
            @change="handleChangeCompany"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.orgName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="targetAttend.dept" :label="targetAttend.dept">
          <el-select
            v-model="form.deptId"
            filterable
            placeholder="请选择"
            @change="handleChangeDept"
          >
            <el-option
              v-for="item in deptList"
              :key="item.value"
              :label="item.orgName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">确认签到</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getOrgListByPid, insertSigninfo } from "@/api/login";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        userType: "",
        companyId: "",
        companyName: "",
        deptId: "",
        deptName: "",
      },
      info: {},
      attendRules: {
        // "1": ['医务人员'],
        // "2": ['连锁药房', '商务来宾'],
        // "3": ['医务人员', '商务来宾'],
        1: ["0"],
        2: ["1", "2"],
        3: ["0", "2"],
      },
      attendList: [
        {
          keyword: "医务人员",
          company: "医院",
          dept: "科室",
          userType: "1",
        },
        {
          keyword: "连锁药房",
          company: "药店",
          dept: "门店",
          userType: "2",
        },
        {
          keyword: "商务来宾",
          company: "单位",
          dept: "部门",
          userType: "3",
        },
      ],
      targetAttend: {},
      companyList: [],
      deptList: [],
    };
  },

  created() {
    this.info = this.$route.params.info;
    const meetType = this.info.meetType;
    let arr = [];
    this.attendRules[meetType].forEach((item) => {
      arr.push(this.attendList[parseInt(item)]);
    });
    console.log(arr, "arr");
    this.attendList = arr;
    Object.keys(this.form).length != 0 &&
      Object.keys(this.form).forEach(
        (key) => (this.form[key] = this.info[key])
      );
    console.log(this.form, 118);
    if (this.form.userType) {
      this.targetAttend = this.attendList.find(
        (item) => item.userType == this.form.userType
      );

      this.companyList = [
        { id: this.form.companyId, orgName: this.form.companyName },
      ];
      this.deptList = [{ id: this.form.deptId, orgName: this.form.deptName }];
    }
  },

  components: {},

  computed: {},

  methods: {
    onSubmit() {
      const obj = Object.assign(this.info, this.form);
      insertSigninfo(obj)
        .then((res) => {
          console.log(res, 3);
          this.$router.push({
            name: "meetinglink",
            params: { result: res.result },
          });
          this.ext02;
        })
        .catch((err) => {
          console.log(err, 2);
        });
    },
    handleChangeAttend(userType) {
      this.form.userType = userType;
      this.targetAttend = this.attendList.find(
        (item) => item.userType == userType
      );
      this.form.companyId = "";
      this.form.companyName = "";
      this.form.deptId = "";
      this.form.deptName = "";
    },
    handleChangeCompany(id) {
      this.form.companyName = this.companyList.find(
        (item) => item.id == id
      ).orgName;
      console.log(this.form.companyName);
      const idd = this.companyList.find((item) => item.id == id).id;
      let params = {
        pid: idd,
        orgName: "",
        userType: this.form.userType,
      };
      getOrgListByPid(params).then((res) => {
        this.deptList = res.result;
        this.form.deptId = this.deptList[0].id;
        this.form.deptName = this.deptList[0].orgName;
      });
    },
    handleChangeDept(id) {
      console.log(id);
      this.form.deptName = this.deptList.find((item) => item.id == id).orgName;
    },
    remoteMethod(e) {
      let params = {
        pid: 0,
        orgName: e,
        userType: this.form.userType,
      };
      getOrgListByPid(params).then((res) => {
        this.companyList = res.result;
      });
    },
  },
};
</script>
<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background-color: rgb(242, 242, 242);
  display: flex;
  justify-content: center;
  /* align-items: center; */
  /* margin-top: 200px; */
  padding-top: 200px;
}
</style>